<template>
  <div class="info-box">
    <div class="info-box__content">
      <h4>{{ title }}</h4>
      <p v-html="description"></p>
    </div>
    <footer v-if="hasFooter">
      <Btn v-if="href" color="white" :href="href" target="_blank" data-test-id="info-box-link">
        {{ $t('action.learnMore') }}
      </Btn>
      <Btn v-if="dismissable" color="ghost" @click="$emit('hide')" data-test-id="info-box-hide">
        {{ $t('action.hide') }}
      </Btn>
    </footer>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  emits: { hide: null },
  name: 'InfoBox',

  props: {
    title: {
      type: String,
      required: true,
    },

    description: {
      type: String,
      required: true,
    },

    dismissable: {
      type: Boolean,
      default: true,
    },

    href: {
      type: String,
      default: null,
    },
  },

  computed: {
    hasFooter(): boolean {
      return this.dismissable || Boolean(this.href);
    },
  },
});
</script>

<style lang="scss" scoped>
@use 'settings/colors';
@use 'settings/settings';
@use 'mixins/typography';

.info-box {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  width: 100%;

  color: colors.$color-grey-900;
  background-color: colors.$color-blue-50;
  border: 1px solid colors.$color-blue-200;
  border-radius: settings.$border-radius;

  &__content {
    display: flex;
    flex-direction: column;
    gap: 8px;

    h4 {
      margin: 0;
      @include typography.typography-15-medium(24px);
    }

    p {
      @include typography.typography-15-normal(24px);
    }
  }

  footer {
    display: flex;
    flex-direction: row;
    gap: 8px;
    width: 100%;
  }
}
</style>
